<template>
  <!-- Tailwind-powered transition (no named CSS classes needed) -->
  <transition
    enter-active-class="transition-all duration-1000 ease-out"
    leave-active-class="transition-all duration-1000 ease-out"
    enter-from-class="-translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="-translate-y-full opacity-0"
  >
    <div
      v-if="show"
      :class="[
        // container frame
        'absolute inset-x-0 w-full z-9999',
        // height & top offset
        toastTopClass,          // returns h-[112px] + top-[*] classes
        // padding & bg via toastClasses
        'px-6 py-6',
        toastClasses,
        // optional: slight shadow & rounded feel
        'shadow-md'
      ]"
      @click="clickable ? toastClicked() : null"
    >
      <div class="flex items-start justify-center gap-3">
        <img :src="icon" class="size-4 mt-0.5" alt="" />
        <div>
          <div class="scio-weight-heading">
            {{ title }}
          </div>
          <div class="scio-text-body font-normal">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: false },
    message: { type: String, required: false },
    toastType: {
      type: String,
      required: true,
      validator(value) {
        return ['success', 'error', 'info', 'warning'].includes(value);
      },
    },
    clickable: { type: Boolean, default: true },
    topOffset: { type: Number, default: null }, // e.g., 70 or 112
  },
  computed: {
    toastClasses() {
      return {
        'bg-scio-green-p3': this.toastType === 'success',
        'bg-scio-red-p3': this.toastType === 'error' || this.toastType === 'warning',
        'bg-scio-grey-n4': this.toastType === 'info',
      };
    },
    icon() {
      switch (this.toastType) {
        case 'success':
          return '/icons/scio-tick-circle-01.svg';
        case 'error':
          return '/icons/scio-risk-circle-01.svg';
        case 'info':
          return '/icons/scio-tick-circle-01.svg';
        case 'warning':
          return '/icons/scio-risk-circle-01.svg';
        default:
          return '';
      }
    },
    toastTopClass() {
      // Keep toast positioning aligned to the authenticated top bar height.
      if (this.topOffset === 112) return 'top-[112px] h-[112px]';
      return 'top-[56px] h-[112px]';
    },
  },
  methods: {
    toastClicked() {
      this.$emit('toastClicked', this.toastType);
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        setTimeout(() => this.$emit('close'), 5000);
      }
    },
  },
};
</script>